export const CHUNK_SIZE = 1000;
export const PLAYER_VIEW_LENGTH = 100;
export const OFFSET = CHUNK_SIZE / 2;
export const MOVE_OFFSET = 5;
